import PropTypes from 'prop-types';
import React from 'react';
import ThreeArrowsIcon from "./three-arrows-icon";

var MoveCountryButton = function MoveCountryButton(_ref) {
  var thisListType = _ref.thisListType,
      theOtherListType = _ref.theOtherListType,
      selectedCountriesNumber = _ref.selectedCountriesNumber,
      onCountryMove = _ref.onCountryMove,
      theOtherListLabel = _ref.theOtherListLabel,
      forward = _ref.forward,
      formatMessage = _ref.formatMessage,
      messages = _ref.messages;

  var handleCountryMove = function handleCountryMove() {
    return onCountryMove(thisListType, theOtherListType);
  };

  return React.createElement("div", {
    className: "MoveCountryButton",
    onClick: handleCountryMove
  }, React.createElement(ThreeArrowsIcon, {
    reversed: true,
    isHidden: forward
  }), React.createElement("div", {
    className: "MoveCountryButton-text"
  }, React.createElement("p", null, formatMessage(messages.moveSelectedLabel), " (".concat(selectedCountriesNumber, ")")), React.createElement("p", null, formatMessage(messages.moveToLabel), React.createElement("b", null, " ".concat(theOtherListLabel)))), React.createElement(ThreeArrowsIcon, {
    reversed: false,
    isHidden: !forward
  }));
};

MoveCountryButton.propTypes = {
  thisListType: PropTypes.string.isRequired,
  theOtherListType: PropTypes.string.isRequired,
  selectedCountriesNumber: PropTypes.number.isRequired,
  onCountryMove: PropTypes.func,
  theOtherListLabel: PropTypes.string.isRequired,
  forward: PropTypes.bool.isRequired,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.object.isRequired
};
export default MoveCountryButton;